import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface Notification {
  message: string;
  severity: 'success' | 'error' | 'info' | 'warning';
  open: boolean;
}

interface UIState {
  notification: Notification | null;
}

const initialState: UIState = {
  notification: null,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    showNotification: (state, action: PayloadAction<Omit<Notification, 'open'> & { open?: boolean }>) => {
      state.notification = {
        ...action.payload,
        open: true,
      };
    },
    hideNotification: (state) => {
      if (state.notification) {
        state.notification.open = false;
      }
    },
    clearNotification: (state) => {
      state.notification = null;
    },
  },
});

export const { showNotification, hideNotification, clearNotification } = uiSlice.actions;
export default uiSlice.reducer; 